export const BODY_SIZE = 16
export const FALLBACK_FONTS = `-apple-system,'Helvetica Neue', sans-serif`
export const REGULAR_FONT = {
  NAME: `MessinaSans`,
  WEIGHT: 500,
}
export const BOLD_FONT = {
  NAME: `MessinaSansCondensed`,
  WEIGHT: 700,
}
export const SEMI_BOLD_FONT = {
  NAME: `MessinaSansMono`,
  WEIGHT: 600,
}
export const BODY_COLOR = `#19282D`

export const BACKGROUND = `#E4E3DD`

export const SPACING = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 36,
  8: 48,
  9: 64,
  10: 80,
}
export const FONT_SIZE = {
  LARGE: 49,
  TITLE: 25,
  SUBTITLE: 20,
  CAPTION: 13,
}
